(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kmart-editable-category-carousel"] && !Shopify.designMode) return;
  try {
    
const initKmartCategoryCarousel=(root)=>{if(!root||root.dataset.ready==='true')return;root.dataset.ready='true';const track=root.querySelector('.kmart-editable-categories__track');const prev=root.querySelector('.kmart-editable-categories__nav--prev');const next=root.querySelector('.kmart-editable-categories__nav--next');const desktop=window.matchMedia('(min-width: 769px)');if(!track||!prev||!next)return;const step=()=>{const item=track.querySelector('.kmart-editable-categories__item');if(!item)return 0;return item.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0)};const update=()=>{const max=Math.max(0,track.scrollWidth-track.clientWidth);const start=parseFloat(getComputedStyle(track).paddingLeft)||0;prev.disabled=track.scrollLeft<=start+2;next.disabled=track.scrollLeft>=max-2;root.classList.toggle('is-static',max<=2)};const move=(direction)=>{track.scrollBy({left:direction*step()*(desktop.matches?6:4),behavior:'smooth'})};prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);desktop.addEventListener?.('change',update);new ResizeObserver(update).observe(track);update()};document.querySelectorAll('[data-kmart-category-carousel]').forEach(initKmartCategoryCarousel);document.addEventListener('shopify:section:load',(event)=>{initKmartCategoryCarousel(event.target.querySelector('[data-kmart-category-carousel]'))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
